/**
 * BulkWarehouseModal Component
 * Toplu depo seçim modalı
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Alert,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import { Warehouse } from '../types/invoice.types';

interface BulkWarehouseModalProps {
  open: boolean;
  onClose: () => void;
  warehouses: Warehouse[];
  selectedWarehouse: string;
  onWarehouseChange: (warehouseId: string) => void;
  onApply: () => void;
  itemCount: number;
}

export const BulkWarehouseModal: React.FC<BulkWarehouseModalProps> = ({
  open,
  onClose,
  warehouses,
  selectedWarehouse,
  onWarehouseChange,
  onApply,
  itemCount,
}) => {
  const { i18n } = useTranslation();
  const isTr = i18n.language.startsWith('tr');
  const tt = (trText: string, enText: string) => (isTr ? trText : enText);

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <WarehouseIcon />
            <Typography variant="h6">{tt('Toplu Depo Seçimi', 'Bulk Warehouse Selection')}</Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mb: 2 }}>
          {tt('Seçilen depo, faturadaki ', 'Selected warehouse will be applied to ')}
          <strong>{tt('tüm ürünlere', 'all items')}</strong>
          {` (${itemCount} ${tt('adet', 'items')}).`}
        </Alert>
        
        <FormControl fullWidth>
          <InputLabel>{tt('Depo Seçin', 'Select Warehouse')}</InputLabel>
          <Select
            value={selectedWarehouse}
            label={tt('Depo Seçin', 'Select Warehouse')}
            onChange={(e) => onWarehouseChange(e.target.value)}
          >
            {warehouses.map((warehouse) => (
              <MenuItem key={warehouse.id} value={warehouse.id}>
                {warehouse.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{tt('İptal', 'Cancel')}</Button>
        <Button 
          onClick={onApply} 
          variant="contained" 
          color="primary"
          disabled={!selectedWarehouse}
        >
          {tt('Uygula', 'Apply')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

